const mainMap = 'https://firebasestorage.googleapis.com/v0/b/dead-island-2-eaaaa.appspot.com/o/assets%2FHell-A.jpg?alt=media&token=0b8b1aad-7807-45e4-bd5d-cec646c32695'

const mapAreas = [
  {
    id: 'layer0',
    label: 'Bel-air',
    coordinates: [
      [
       {xPercentage: 31, yPercentage: 12},
       {xPercentage: 44.044444444444444, yPercentage: 28},
      ]
    ]
  }, {
    id: 'layer1',
    label: 'Santa Monica Pier',
    coordinates: [
      [
        {xPercentage: 19.511111111111113, yPercentage: 32},
        {xPercentage: 29.733333333333334, yPercentage: 52.02380042787286},
      ]
    ]
  }, {
    id: 'layer2',
    label: 'Beverly Hills',
    coordinates: [
      [
        {xPercentage: 51, yPercentage: 32},
        {xPercentage: 67, yPercentage: 43},
      ]
    ]
  }, {
    id: 'layer3',
    label: 'Brentwood Sewer',
    coordinates: [
      [
        {xPercentage: 63.511111111111106, yPercentage: 63.63749235941321},
        {xPercentage: 78.62222222222222, yPercentage: 72},
      ]
    ]
  }, {
    id: 'layer4',
    label: 'Halperin Hotel',
    coordinates: [
      [
        {xPercentage: 37, yPercentage: 30},
        {xPercentage: 49, yPercentage: 44},
      ]
    ]
  }, {
    id: 'layer5',
    label: 'Hollywood Boulevard',
    coordinates: [
      [
        {xPercentage: 85, yPercentage: 41},
        {xPercentage: 91.77777777777779, yPercentage: 62},
      ]
    ]
  }, {
    id: 'layer6',
    label: 'Monarch Studios',
    coordinates: [
      [
        {xPercentage: 74.97777777777777, yPercentage: 32},
        {xPercentage: 84.22222222222221, yPercentage: 53.00179553789731},
      ]
    ]
  }, {
    id: 'layer7',
    label: 'Ocean Avenue',
    coordinates: [
      [
        {xPercentage: 41.02222222222222, yPercentage: 49},
        {xPercentage: 57.46666666666667, yPercentage: 58},
      ]
    ]
  }, {
    id: 'layer8',
    label: 'The Metro',
    coordinates: [
      [
        {xPercentage: 61, yPercentage: 50.67905715158925},
        {xPercentage: 73.91111111111111, yPercentage: 62},
      ]
    ]
  }, {
    id: 'layer9',
    label: 'Venice Beach',
    coordinates: [
      [
        {xPercentage: 38.977777777777774, yPercentage: 60.58125764058679},
        {xPercentage: 52.577777777777776, yPercentage: 76},
      ]
    ]
  }
]

function findIntersectingObject(x, y, items) {
  for (const item of items) {
    for (const coordinatePair of item.coordinates) {
      const [coord1, coord2] = coordinatePair;
      if (x >= coord1.xPercentage && x <= coord2.xPercentage &&
          y >= coord1.yPercentage && y <= coord2.yPercentage) {
        return item;
      }
    }
  }
  return null;
}

function getLayerName(id) {
  return mapAreas.find(i => i.id === id).label
}

function getImageBoundingRect(img) {
  const imgRect = img.getBoundingClientRect();
  const imgAspectRatio = img.naturalWidth / img.naturalHeight;
  const containerAspectRatio = imgRect.width / imgRect.height;

  let width, height, x, y;

  if (imgAspectRatio > containerAspectRatio) {
    width = imgRect.width;
    height = imgRect.width / imgAspectRatio;
    x = imgRect.x;
    y = imgRect.y + (imgRect.height - height) / 2;
  } else {
    height = imgRect.height;
    width = imgRect.height * imgAspectRatio;
    x = imgRect.x + (imgRect.width - width) / 2;
    y = imgRect.y;
  }

  return {
    x: x,
    y: y,
    width: width,
    height: height,
  };
}

function createDomElements(data, img, container, close) {
  const {
    x: x,
    y: y,
    width: width,
    height: height,
  } = getImageBoundingRect(img)
  container.style = `
    position: absolute;
    left: ${x}px;
    top: ${y}px;
    width: ${width}px;
    height: ${height}px;
    z-index: 999;
  `
  data.forEach(item => {
    item.coordinates.forEach(coordPair => {
      const [coord1, coord2] = coordPair;
      const element = document.createElement('div');
      element.id = item.id;
      element.className = 'track-area showTitle'
      element.title = item.label
      element.textContent = item.label;
      element.style.position = 'absolute';
      element.style.left = `${coord1.xPercentage}%`;
      element.style.top = `${coord1.yPercentage}%`;
      element.style.width = `${coord2.xPercentage - coord1.xPercentage}%`;
      element.style.height = `${coord2.yPercentage - coord1.yPercentage}%`;
      element.style.border = '1px solid black';
      element.style.boxSizing = 'border-box';
      container.appendChild(element);
    });
  });

  close.style.left = `${x + width - 22}px`
  close.style.top = `${y - 18}px`
  close.style.opacity = .8

  return container;
}

export class MapSwitcher extends HTMLElement {

  layerSelected = 'layer0'

  constructor() {
    super();
  }

  close() {
    return this.querySelector('.main-map-container').style.display = 'none';
  }

  getImageClickPercentage(event, imageElement) {
    const rect = imageElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercentage = (x / imageElement.clientWidth) * 100;
    const yPercentage = (y / imageElement.clientHeight) * 100;

    return { xPercentage, yPercentage };
  }

  triggerLayerChange(val) {
    const evt = new CustomEvent("onswitch", {
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: val
    });
    this.dispatchEvent(evt);
  }

  hideMainLayer(val) {
    this.querySelector('.main-map-container').style.display = 'none';
    const el = this.querySelector('.map-switcher-container')
    this.layerSelected = val
    el.firstElementChild.innerHTML = getLayerName(val)
  }

  handleEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.srcElement.classList.contains('e:close')) {
      return this.close()
    }
    if (event.srcElement.classList.contains('reel-toggler')) {
      this.querySelector('.main-map-container').style.display = 'block';
    }
    if (event.srcElement.classList.contains('e:map')) {
      const {xPercentage, yPercentage} = this.getImageClickPercentage(event, event.srcElement)
    }
    if (event.srcElement.classList.contains('track-area')) {
      if (event.srcElement.id !== this.layerSelected) {
        this.triggerLayerChange(event.srcElement.id)
      }
      this.hideMainLayer(event.srcElement.id)
    }
  }

  updateDomElements() {
    const container = this.querySelector('#track-map-areas')
    const img = this.querySelector('#main-map')
    const close = this.querySelector('.close-switcher')
    createDomElements(mapAreas, img, container, close);
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        .close-switcher {
          background: black;
          position: absolute;
          right: 0;
          top: 0;
          width: 40px;
          height: 40px;
          font-size: 30px;
          border: 2px solid white;
          border-radius: 50%;
          color: white;
          z-index: 999;
          cursor: pointer;
          opacity: 0;
        }
        .close-switcher:hover {
          color: red;
        }
        .map-switcher-container {
          position: absolute;
          right: 0;
          bottom: 0;
          padding: 20px;
          background: #2b2b2b;
          color: white;
          margin: 20px;
          border-radius: 5px;
          border: 1px solid #8e8e8e;
          cursor: pointer;
          user-select: none;
        }
        .map-switcher-container:hover {
          filter: brightness(1.5);
        }
        .map-switcher-container.active ~ .map-switcher-reel {
          position: absolute;
          right: 120px;
          bottom: 40px;
        }
        .map-switcher-reel .rtoggle {
          padding: 18px;
          background: #2b2b2b;
          color: white;
          margin: 0;
          border-radius: 5px;
          border: 1px solid #8e8e8e;
          cursor: pointer;
          user-select: none;
        }
        .map-switcher-reel input {
          display: none;
        }
        .main-map-container {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(0,0,0,.7);
          z-index: 99;
        }
        #main-map, .main-map {
          position: absolute;
          width: 90vw;
          height: 90vh;
          top: 5vh;
          left: 5vw;
          z-index: 99;
          object-fit: contain;
        }
        .area {
          outline: 2px solid red;
        }
        .track-area {
          opacity: 0;
          color: white;
          cursor: pointer;
          border: 1px solid transparent !important;
        }
        .track-area:hover {
          opacity: 1;
          color: transparent;
          background: rgba(255, 255, 255, .5);
          border-radius: 50%;
        }

        .showTitle:hover {
          text-decoration: none;
        }

        .showTitle:hover:after {
          background: #111;
          background: rgba(0, 0, 0, .8);
          border-radius: .5em;
          color: #fff;
          content: attr(title);
          display: block;
          padding: .3em 1em;
          position: absolute;
          text-shadow: 0 1px 0 #000;
          white-space: nowrap;
          z-index: 98;
          top: -30px;
          left: calc(50% - 40px);
        }

      </style>

      <div class="main-map-container">
        <img id="main-map" class="click e:map"  src="${mainMap}" usemap="#image-map">
        <div id="track-map-areas" class="click"></div>
        <button class="close-switcher click e:close" type="button" aria-label="Close popup" aria-hidden="true">×</button>
      </div>

      <div class="map-switcher-container click reel-toggler">
        <div class="click reel-toggler">${getLayerName(this.layerSelected)}</div>
      </div>

      <div class="map-switcher-reel" style="display:none">
        <label class="rtoggle" for="layer0">layer0</label>
        <input id="layer0" type="radio" name="rtoggle" value="layer0">
        <label class="rtoggle" for="layer1">layer1</label>
        <input id="layer1" type="radio" name="rtoggle" value="layer1">
        <label class="rtoggle" for="layer2">layer2</label>
        <input id="layer2" type="radio" name="rtoggle" value="layer2">
        <label class="rtoggle" for="layer3">layer3</label>
        <input id="layer3" type="radio" name="rtoggle" value="layer3">
        <label class="rtoggle" for="layer4">layer4</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer4">
        <label class="rtoggle" for="layer5">layer5</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer5">
        <label class="rtoggle" for="layer6">layer6</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer6">
        <label class="rtoggle" for="layer7">layer7</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer7">
        <label class="rtoggle" for="layer8">layer8</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer8">
        <label class="rtoggle" for="layer9">layer9</label>
        <input id="layer4" type="radio" name="rtoggle" value="layer9">
      </div>
    `
    this.querySelectorAll('.click').forEach(node => node.addEventListener("click", this))
    this.querySelectorAll('[name="rtoggle"]').forEach(node => node.addEventListener('change', this))

    this.handleResize = () => {
      this.updateDomElements();
    };

    window.addEventListener('resize', this.handleResize);
    setTimeout(() => this.updateDomElements(), 500)

  }
}

window.customElements.define("map-switcher", MapSwitcher);
